import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import InternContainerComponent from './InternContainerComponent';
import mbaInternList from './MbaTeam';
import UserInfoContainer from './UserInfoContainer';
import { connect } from 'react-redux';
import store, { cecPageNo, twaPageNo, mbaPageNo, schoolPageNo, collegePageNo } from '../../../redux/store';

// ES6 classNameNameNameName-style
class MBA extends PreLoginSessionCheck {

	constructor(props) {
		super(props);
		this.state = {
			profileData: null,
			userClicked: false
		}

	}
	componentDidMount() {
		this.setState({ profileData: null, userClicked: false });
	}
	hideFn = (profileData) => {
		this.setState({ profileData: profileData, userClicked: true });
	}
	closeFn = () => {
		this.setState({ profileData: null, userClicked: false });
	}

	render() {
		console.log("Calling MBA.....")
		return (
			<div>
				<div className="header">
					<p>From implementing design thinking principles to real products and developing social media strategies to reach new users to analytics and financial modeling, HeyMath! offers dynamic projects to MBA students every year.</p>
					<p>Previous interns have described their experience as ‘fast and furious’, invigorating, enjoyable, empowering and ‘more than what I expected’.</p>
				</div>
				{
					(() => {
						if (this.state.userClicked) {
							return (
								<UserInfoContainer userData={this.state.profileData} closeFn={this.closeFn}></UserInfoContainer>
							)
						} else {
							return (
								<InternContainerComponent getPageValue={this.props.getPageValue} decrementFn={this.props.decrementFn} incrementFn={this.props.incrementFn} profileClickedFn={this.hideFn} internList={mbaInternList}></InternContainerComponent>
							)
						}
					})()
				}
			</div>
		);
	}
}

const getStateData = (state) => {
	return {
		getPageValue: () => {
			//console.log("removeData ");
			return state.mbaPageNo
		}
	}
}

const setStateData = (dispatch) => {
	return {
		incrementFn: () => {
			//console.log("addData ",addData);
			dispatch({ type: "mba_pageno_increment" })
		},
		decrementFn: () => {
			//console.log("removeData ");
			dispatch({ type: "mba_pageno_decrement" })
		}
	}
}

export default connect(getStateData, setStateData)(MBA);


// WEBPACK FOOTER //
// ./src/prelogin/src/components/MBA.js